import { createAction } from '@ngrx/store';

export const ToggleWebPlayerSportAction = createAction(
  '[Web Player] Toggle Sport',
  (payload = null) => ({ payload })
);
export const ToggleWebPlayerDropdownAction = createAction(
  '[Web Player] Toggle Dropdown',
  (payload = null) => ({ payload })
);
export const RedirectWebPlayerAction = createAction(
  '[Web Player] Redirect',
  (payload = null) => ({ payload })
);
